import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api, resolveImg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { InfoCard } from "@/components/InfoCard";

export function HomeHero({ site, username, infos }) {
  const welcome = site?.welcome_text || "COREXE INFO PUGLIC'E HOŞ GELDİN";
  const totalBuyers = (infos || []).reduce((a, i) => a + (i.buyers_count || 0), 0);
  return (
    <section className="relative overflow-hidden border-b border-slate-800/60">
      {site?.hero_image && <img src={resolveImg(site.hero_image)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />}
      <div className="absolute inset-0 bg-gradient-to-b from-[#05070D]/40 via-[#05070D]/70 to-[#05070D]" />
      <div className="absolute inset-0 cx-grid-bg opacity-60" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-20 sm:py-28">
        <p className="font-mono-cx text-xs uppercase tracking-[0.35em] mb-5 cx-fade-up" style={{ color: "var(--cx-cyan)" }}>
          // {site?.hero_eyebrow || `${username || ""} olarak giriş yapıldı`}
        </p>
        <h1 data-testid="home-welcome-heading" className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-50 leading-[1.05] max-w-4xl cx-fade-up" style={{ animationDelay: "80ms" }}>
          {welcome}
        </h1>
        {site?.welcome_subtitle && <p className="mt-6 text-base md:text-lg text-slate-400 max-w-2xl leading-relaxed cx-fade-up" style={{ animationDelay: "160ms" }}>{site.welcome_subtitle}</p>}
        {site?.show_stats && (
          <div className="mt-10 flex flex-wrap gap-4 cx-fade-up" data-testid="home-stats">
            <div className="cx-glass rounded-xl px-5 py-3"><p className="font-display text-xl font-bold text-slate-50 leading-none">{infos ? infos.length : "—"}</p><p className="text-[11px] text-slate-500 mt-1 uppercase tracking-wider font-mono-cx">Bilgi Paketi</p></div>
            <div className="cx-glass rounded-xl px-5 py-3"><p className="font-display text-xl font-bold text-slate-50 leading-none">{infos ? totalBuyers : "—"}</p><p className="text-[11px] text-slate-500 mt-1 uppercase tracking-wider font-mono-cx">Toplam Satın Alma</p></div>
          </div>
        )}
      </div>
    </section>
  );
}

export function HomeSections({ sections }) {
  if (!sections || sections.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 pb-16 space-y-8" data-testid="home-custom-sections">
      {sections.map((s, i) => (
        <div key={s.id || i} data-testid="home-custom-section" className={`cx-glass rounded-3xl overflow-hidden grid ${s.image_url ? "md:grid-cols-2" : ""} cx-fade-up`}>
          {s.image_url && <img src={resolveImg(s.image_url)} alt="" className={`h-64 md:h-full w-full object-cover ${i % 2 ? "md:order-2" : ""}`} />}
          <div className="p-8 sm:p-10 flex flex-col justify-center">
            {s.title && <h3 className="font-display text-2xl sm:text-3xl font-bold text-slate-50">{s.title}</h3>}
            {s.text && <p className="text-slate-300 mt-4 leading-relaxed whitespace-pre-wrap">{s.text}</p>}
          </div>
        </div>
      ))}
    </section>
  );
}

export default function HomePage() {
  const { user, site } = useAuth();
  const [infos, setInfos] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/infos").then((r) => alive && setInfos(r.data)).catch(() => alive && setInfos([]));
    load();
    const t = setInterval(load, 15000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <div>
      <HomeHero site={site} username={user?.username} infos={infos} />

      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] mb-2 inline-flex items-center gap-2" style={{ color: "var(--cx-cyan)" }}><Sparkles className="h-3 w-3" /> {site?.cards_title || "Bilgi Paketleri"}</p>
            <h2 className="font-display text-base md:text-lg font-semibold text-slate-200">{site?.cards_subtitle || "Aşağıdaki paketlerden birini seç, önizlemeyi incele, satın al."}</h2>
          </div>
        </div>
        {infos === null ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {[0, 1, 2].map((i) => <div key={i} className="h-[420px] rounded-2xl bg-slate-900/60 animate-pulse" />)}
          </div>
        ) : infos.length === 0 ? (
          <div className="cx-glass rounded-2xl p-12 text-center text-slate-400" data-testid="no-infos-message">Henüz bilgi paketi eklenmemiş.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid="info-cards-grid">
            {infos.map((info, i) => <InfoCard key={info.id} info={info} index={i} />)}
          </div>
        )}
      </section>

      <HomeSections sections={site?.sections} />
    </div>
  );
}
